import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, unref as _unref, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "form-field-floating reactive active my-5" }
const _hoisted_2 = {
  key: 0,
  class: "text-red"
}
const _hoisted_3 = { class: "form-field-floating reactive my-5" }
const _hoisted_4 = {
  key: 1,
  class: "text-red"
}
const _hoisted_5 = { class: "form-field-split my-5" }
const _hoisted_6 = { class: "form-field-floating reactive half" }
const _hoisted_7 = { class: "form-field-floating reactive half" }
const _hoisted_8 = {
  key: 2,
  class: "text-red"
}
const _hoisted_9 = {
  key: 3,
  class: "text-red"
}
const _hoisted_10 = { class: "form-field-split my-5" }
const _hoisted_11 = { class: "form-field-floating reactive half" }
const _hoisted_12 = { class: "form-field-floating reactive half" }
const _hoisted_13 = {
  key: 4,
  class: "text-red"
}
const _hoisted_14 = {
  key: 5,
  class: "text-red"
}
const _hoisted_15 = {
  key: 6,
  class: "form-field-floating full my-5"
}
const _hoisted_16 = ["value"]
const _hoisted_17 = {
  key: 7,
  class: "text-red"
}
const _hoisted_18 = { class: "form-field-floating reactive active my-5" }
const _hoisted_19 = {
  key: 0,
  class: "text-red"
}
const _hoisted_20 = { class: "form-field-split active my-5" }
const _hoisted_21 = { class: "form-field-floating reactive half" }
const _hoisted_22 = { class: "form-field-floating reactive half" }
const _hoisted_23 = {
  key: 1,
  class: "text-red"
}
const _hoisted_24 = {
  key: 2,
  class: "text-red"
}
const _hoisted_25 = { class: "form-field-split active my-5" }
const _hoisted_26 = { class: "form-field-floating reactive half" }
const _hoisted_27 = {
  key: 3,
  class: "text-red"
}

import { reactive, ref, watch } from 'vue';
    import axios from 'axios';
    import moment from 'moment';
    import { AMOUNT_FORMAT_CONFIG, PERCENTAGE_FORMAT_CONFIG } from '@/utils';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'OnboardingPersonalInfosForm',
  props: {
        collectivites: { type: Object, required: true },
        hideCollectiviteField: { type: Boolean, default: false },
        hideSubmitButton: { type: Boolean, default: false },
        fullWidth: { type: Boolean, default: false },
    },
  emits: ['saved'],
  setup(__props, { expose: __expose, emit: __emit }) {

    // @ts-expect-error raison: lib externe mal typée
    const props = __props;
    const emit = __emit;
    const errorMessage = ref('');
    const loading = ref(false);
    const isFormValid = ref(false);
    const formData = reactive({
        nom: null as string | null,
        prenom: null as string | null,
        date_naissance: null as string | null,
        age: 0,
        date_engagement: null as string | null,
        anciennete: 0,
        collectivite_id: null as number | null,
        salaire: "",
        quotite_cessible_pourcent: "",
        quotite_cessible_montant: "",
        telephone: null as string | null,
        email: null as string | null,
    });
    const errors = reactive({
        nom: "",
        prenom: "",
        date_naissance: "",
        age: "",
        date_engagement: "",
        anciennete: "",
        collectivite_id: "",
        salaire: "",
        quotite_cessible_pourcent: "",
        quotite_cessible_montant: "",
        telephone: "",
        email: "",
        pays_id: ""
    });
    const countries = [
        { name: 'États-Unis', code: 'US', dial: '+1' },
        { name: 'Canada', code: 'CA', dial: '+1' },
        { name: 'Sénégal', code: 'SN', dial: '+221' },
        { name: 'Mali', code: 'ML', dial: '+223' },
        { name: 'Guinée', code: 'GN', dial: '+224' },
        { name: 'Côte d’Ivoire', code: 'CI', dial: '+225' },
        { name: 'Burkina Faso', code: 'BF', dial: '+226' },
        { name: 'Niger', code: 'NE', dial: '+227' },
        { name: 'Togo', code: 'TG', dial: '+228' },
        { name: 'Bénin', code: 'BJ', dial: '+229' },
        { name: 'Ghana', code: 'GH', dial: '+233' },
        { name: 'Nigeria', code: 'NG', dial: '+234' },
        { name: 'Rwanda', code: 'RW', dial: '+250' },
        { name: 'Éthiopie', code: 'ET', dial: '+251' },
        { name: 'Kenya', code: 'KE', dial: '+254' },
        { name: 'Tanzanie', code: 'TZ', dial: '+255' },
        { name: 'Afrique du Sud', code: 'ZA', dial: '+27' },
        { name: 'Belgique', code: 'BE', dial: '+32' },
        { name: 'France', code: 'FR', dial: '+33' },
        { name: 'Luxembourg', code: 'LU', dial: '+352' },
        { name: 'Suisse', code: 'CH', dial: '+41' },
        { name: 'Allemagne', code: 'DE', dial: '+49' },
        { name: 'Mexique', code: 'MX', dial: '+52' },
        { name: 'Brésil', code: 'BR', dial: '+55' },
        { name: 'Japon', code: 'JP', dial: '+81' },
        { name: 'Chine', code: 'CN', dial: '+86' },
        { name: 'Inde', code: 'IN', dial: '+91' },
        { name: 'Émirats Arabes Unis', code: 'AE', dial: '+971' },
    ];

    watch(formData, (oldFormData, newFormData) => {
        if (newFormData.date_naissance) {
            const birthDate = moment(newFormData.date_naissance);
            if (birthDate.isValid()) {
                const age = moment().diff(birthDate, 'years');
                formData.age = age;
            }
        }
        if (newFormData.date_engagement) {
            const engagementDate = moment(newFormData.date_engagement);
            if (engagementDate.isValid()) {
                const anciennete = moment().diff(engagementDate, 'years');
                formData.anciennete = anciennete;
            }
        }
    });

    function validate() {
        let isValid = true;

        errors.nom = '';
        if (!formData.nom) {
            errors.nom ="Le nom est requis";
            isValid = false;
        }

        errors.prenom = '';
        if (!formData.prenom) {
            errors.prenom ="Le prénom est requis";
            isValid = false;
        }

        errors.date_naissance = '';
        if (!formData.date_naissance) {
            errors.date_naissance ="La date de naissance est requise";
            isValid = false;
        } else {
            const birthDate = moment(formData.date_naissance);
            if (!birthDate.isValid()) {
                errors.date_naissance ="Le format de la date de naissance est invalide";
                isValid = false;
            }
        }

        errors.age = '';
        if (!formData.age) {
            errors.age ="L'âge est requis";
            isValid = false;
        } else if (isNaN(formData.age) || formData.age <= 0) {
            errors.age ="Le format de l'âge est invalide";
            isValid = false;
        }

        errors.date_engagement = '';
        if (!formData.date_engagement) {
            errors.date_engagement ="La date d'engagement est requise";
            isValid = false;
        } else {
            const engagementDate = moment(formData.date_engagement);
            if (!engagementDate.isValid()) {
                errors.date_engagement ="Le format de la date d'engagement est invalide";
                isValid = false;
            }
        }

        errors.anciennete = '';
        if (!formData.anciennete) {
            errors.anciennete ="L'ancienneté est requise";
            isValid = false;
        } else if (isNaN(formData.anciennete) || formData.anciennete < 0) {
            errors.anciennete ="Le format de l'ancienneté est invalide";
            isValid = false;
        }

        errors.collectivite_id = '';
        if (!props.hideCollectiviteField) {
            if (!formData.collectivite_id) {
                errors.collectivite_id ="La collectivité est requise";
                isValid = false;
            } else if (isNaN(formData.collectivite_id) || formData.collectivite_id <= 0) {
                errors.collectivite_id ="Le format de la collectivité est invalide";
                isValid = false;
            }
        }

        errors.salaire = '';
        if (!formData.salaire) {
            errors.salaire ="Le salaire est requis";
            isValid = false;
        } else if (isNaN(parseFloat(formData.salaire)) || parseFloat(formData.salaire) <= 0) {
            errors.salaire ="Le format du salaire est invalide";
            isValid = false;
        }

        errors.quotite_cessible_pourcent = '';
        if (!formData.quotite_cessible_pourcent) {
            errors.quotite_cessible_pourcent ="La quotité cessible en pourcentage est requise";
            isValid = false;
        } else if (isNaN(parseFloat(formData.quotite_cessible_pourcent)) || parseFloat(formData.quotite_cessible_pourcent) <= 0 || parseFloat(formData.quotite_cessible_pourcent) > 100) {
            errors.quotite_cessible_pourcent ="Le format de la quotité cessible en pourcentage est invalide";
            isValid = false;
        }

        errors.quotite_cessible_montant = '';
        if (!formData.quotite_cessible_montant) {
            errors.quotite_cessible_montant ="La quotité cessible en montant est requise";
            isValid = false;
        } else if (isNaN(parseFloat(formData.quotite_cessible_montant)) || parseFloat(formData.quotite_cessible_montant) <= 0) {
            errors.quotite_cessible_montant ="Le format de la quotité cessible en montant est invalide";
            isValid = false;
        }

        errors.telephone = '';
        if (!formData.telephone) {
            errors.telephone ="Le téléphone est requis";
            isValid = false;
        }

        errors.email = '';
        if (!formData.email) {
            errors.email ="L'email est requis";
            isValid = false;
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            errors.email = "Le format de l'email est invalide";
            isValid = false;
        }

        isFormValid.value = isValid;
        
        return isValid;
    }

    async function onSubmit() {
        if (!validate()) { return; }
        const formToUpload = {
            nom: formData.nom,
            prenom: formData.prenom,
            date_naissance: formData.date_naissance,
            age: formData.age,
            date_engagement: formData.date_engagement,
            anciennete: formData.anciennete,
            collectivite_id: formData.collectivite_id,
            salaire: formData.salaire,
            quotite_cessible_pourcent: formData.quotite_cessible_pourcent,
            quotite_cessible_montant: formData.quotite_cessible_montant,
            telephone: formData.telephone,
            email: formData.email,
        };
        emit('saved', formToUpload);
    }

    async function doCalculateQuotiteCessible() {
        const salaire = parseFloat(formData.salaire);
        const quotite_cessible_pourcent = parseFloat(formData.quotite_cessible_pourcent);
        if (!salaire || isNaN(salaire) || !quotite_cessible_pourcent || isNaN(quotite_cessible_pourcent)) {
            return;
        }

        loading.value = true;
        errorMessage.value = '';
        try {
            const response = await axios.post(`/backoffice/onboarding/calculate_quotite_cessible`, {
                salaire: formData.salaire,
                quotite_cessible_pourcent: formData.quotite_cessible_pourcent,
            });
            formData.quotite_cessible_montant = response.data.quotite_cessible_montant;
        } catch(error: any) {
            errorMessage.value = error.message;
            console.error(error);
        } finally {
            loading.value = false;
        }
    }

    // Exposer les données et fonctions pour usage externe
    __expose({
        formData,
        validate,
        onSubmit
    });

return (_ctx: any,_cache: any) => {
  const _component_money3 = _resolveComponent("money3")!
  const _component_custom_phone_input = _resolveComponent("custom-phone-input")!

  return (_openBlock(), _createElementBlock("form", {
    class: _normalizeClass(__props.fullWidth ? 'form' : 's20 form')
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(__props.fullWidth ? '' : 'container-full-1')
    }, [
      _cache[23] || (_cache[23] = _createElementVNode("h3", { class: "flex align-items-center gap-4 font-medium text-primary-color my-5" }, [
        _createElementVNode("img", {
          src: "/icons/icon-info-perso.svg",
          class: "size-base",
          alt: ""
        }),
        _createTextVNode(" Informations personnelles ")
      ], -1)),
      _createElementVNode("div", _hoisted_1, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "form-input",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.nom) = $event)),
          name: "nom",
          id: "nom",
          placeholder: ""
        }, null, 512), [
          [_vModelText, formData.nom]
        ]),
        _cache[13] || (_cache[13] = _createElementVNode("label", { for: "nom" }, [
          _createTextVNode("Nom "),
          _createElementVNode("b", { class: "color-danger" }, "*")
        ], -1))
      ]),
      (!!errors['nom'])
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(errors['nom']), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "form-input",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.prenom) = $event)),
          name: "prenom",
          id: "prenom",
          placeholder: ""
        }, null, 512), [
          [_vModelText, formData.prenom]
        ]),
        _cache[14] || (_cache[14] = _createElementVNode("label", { for: "prenom" }, [
          _createTextVNode("Prénoms "),
          _createElementVNode("b", { class: "color-danger" }, "*")
        ], -1))
      ]),
      (!!errors['prenom'])
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(errors['prenom']), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _withDirectives(_createElementVNode("input", {
            type: "date",
            class: "form-input",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.date_naissance) = $event)),
            name: "date_naissance",
            id: "date_naissance",
            placeholder: ""
          }, null, 512), [
            [_vModelText, formData.date_naissance]
          ]),
          _cache[15] || (_cache[15] = _createElementVNode("label", { for: "date_naissance" }, [
            _createTextVNode("Date de naissance "),
            _createElementVNode("b", { class: "color-danger" }, "*")
          ], -1))
        ]),
        _cache[17] || (_cache[17] = _createElementVNode("hr", { class: "hr" }, null, -1)),
        _createElementVNode("div", _hoisted_7, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-input",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.age) = $event)),
            name: "age",
            id: "age",
            placeholder: "",
            readonly: ""
          }, null, 512), [
            [_vModelText, formData.age]
          ]),
          _cache[16] || (_cache[16] = _createElementVNode("label", { for: "age" }, [
            _createTextVNode("Age "),
            _createElementVNode("b", { class: "color-danger" }, "*")
          ], -1))
        ])
      ]),
      (!!errors['date_naissance'])
        ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(errors['date_naissance']), 1))
        : _createCommentVNode("", true),
      (!!errors['age'])
        ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(errors['age']), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _withDirectives(_createElementVNode("input", {
            type: "date",
            class: "form-input",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.date_engagement) = $event)),
            name: "date_engagement",
            id: "date_engagement",
            placeholder: ""
          }, null, 512), [
            [_vModelText, formData.date_engagement]
          ]),
          _cache[18] || (_cache[18] = _createElementVNode("label", { for: "date_engagement" }, [
            _createTextVNode("Date d'engagement "),
            _createElementVNode("b", { class: "color-danger" }, "*")
          ], -1))
        ]),
        _cache[20] || (_cache[20] = _createElementVNode("hr", { class: "hr" }, null, -1)),
        _createElementVNode("div", _hoisted_12, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-input",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.anciennete) = $event)),
            name: "anciennete",
            id: "anciennete",
            placeholder: ""
          }, null, 512), [
            [_vModelText, formData.anciennete]
          ]),
          _cache[19] || (_cache[19] = _createElementVNode("label", { for: "anciennete" }, [
            _createTextVNode("Ancienneté "),
            _createElementVNode("b", { class: "color-danger" }, "*")
          ], -1))
        ])
      ]),
      (!!errors['date_engagement'])
        ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(errors['date_engagement']), 1))
        : _createCommentVNode("", true),
      (!!errors['anciennete'])
        ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(errors['anciennete']), 1))
        : _createCommentVNode("", true),
      (!__props.hideCollectiviteField)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _withDirectives(_createElementVNode("select", {
              class: "form-input-select",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.collectivite_id) = $event)),
              name: "collectivite_id",
              id: "collectivite_id"
            }, [
              _cache[21] || (_cache[21] = _createElementVNode("option", { value: null }, "Sélectionnez votre collectivité", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.collectivites, (collectivite, index) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: collectivite.id,
                  key: 'collectivite_' + index
                }, _toDisplayString(collectivite.nom), 9, _hoisted_16))
              }), 128))
            ], 512), [
              [_vModelSelect, formData.collectivite_id]
            ]),
            _cache[22] || (_cache[22] = _createElementVNode("label", { for: "collectivite_id" }, [
              _createTextVNode("Votre collectivité "),
              _createElementVNode("b", { class: "color-danger" }, "*")
            ], -1))
          ]))
        : _createCommentVNode("", true),
      (!__props.hideCollectiviteField && !!errors['collectivite_id'])
        ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(errors['collectivite_id']), 1))
        : _createCommentVNode("", true)
    ], 2),
    _cache[35] || (_cache[35] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
    _createElementVNode("div", {
      class: _normalizeClass(__props.fullWidth ? '' : 'container-full-1')
    }, [
      _cache[34] || (_cache[34] = _createElementVNode("h3", { class: "flex align-items-center gap-4 font-medium text-primary-color my-5" }, [
        _createElementVNode("img", {
          src: "/icons/icon-engagement.svg",
          class: "size-base",
          alt: ""
        }),
        _createTextVNode(" Engagement ")
      ], -1)),
      _createElementVNode("div", _hoisted_18, [
        _createVNode(_component_money3, _mergeProps({
          class: "form-input",
          modelValue: formData.salaire,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.salaire) = $event)),
          name: "salaire",
          id: "salaire",
          placeholder: ""
        }, _unref(AMOUNT_FORMAT_CONFIG), { onBlur: doCalculateQuotiteCessible }), null, 16, ["modelValue"]),
        _cache[24] || (_cache[24] = _createElementVNode("label", { for: "salaire" }, [
          _createTextVNode("Salaire brut "),
          _createElementVNode("b", { class: "color-danger" }, "*")
        ], -1)),
        _cache[25] || (_cache[25] = _createElementVNode("span", null, "F CFA", -1))
      ]),
      (!!errors['salaire'])
        ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(errors['salaire']), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createVNode(_component_money3, _mergeProps({
            class: "form-input",
            modelValue: formData.quotite_cessible_pourcent,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.quotite_cessible_pourcent) = $event)),
            name: "quotite_cessible_pourcent",
            id: "quotite_cessible_pourcent",
            placeholder: ""
          }, _unref(PERCENTAGE_FORMAT_CONFIG), { onBlur: doCalculateQuotiteCessible }), null, 16, ["modelValue"]),
          _cache[26] || (_cache[26] = _createElementVNode("label", { for: "quotite_cessible_pourcent" }, [
            _createTextVNode("Quotité cessible max "),
            _createElementVNode("b", { class: "color-danger" }, "*")
          ], -1)),
          _cache[27] || (_cache[27] = _createElementVNode("span", { class: "" }, "%", -1))
        ]),
        _cache[30] || (_cache[30] = _createElementVNode("hr", { class: "hr" }, null, -1)),
        _createElementVNode("div", _hoisted_22, [
          _createVNode(_component_money3, _mergeProps({
            class: "form-input",
            modelValue: formData.quotite_cessible_montant,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.quotite_cessible_montant) = $event)),
            name: "quotite_cessible_montant",
            id: "quotite_cessible_montant",
            placeholder: ""
          }, _unref(AMOUNT_FORMAT_CONFIG), { readonly: "" }), null, 16, ["modelValue"]),
          _cache[28] || (_cache[28] = _createElementVNode("label", { for: "quotite_cessible_montant" }, [
            _createTextVNode("Valeur "),
            _createElementVNode("b", { class: "color-danger" }, "*")
          ], -1)),
          _cache[29] || (_cache[29] = _createElementVNode("span", { class: "" }, "F CFA", -1))
        ])
      ]),
      (!!errors['quotite_cessible_pourcent'])
        ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(errors['quotite_cessible_pourcent']), 1))
        : _createCommentVNode("", true),
      (!!errors['quotite_cessible_montant'])
        ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(errors['quotite_cessible_montant']), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_25, [
        _createVNode(_component_custom_phone_input, {
          modelValue: formData.telephone,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData.telephone) = $event)),
          id: "telephone",
          classesNames: "half"
        }, null, 8, ["modelValue"]),
        _cache[32] || (_cache[32] = _createElementVNode("hr", { class: "hr" }, null, -1)),
        _createElementVNode("div", _hoisted_26, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-input",
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formData.email) = $event)),
            name: "email",
            id: "email",
            placeholder: ""
          }, null, 512), [
            [_vModelText, formData.email]
          ]),
          _cache[31] || (_cache[31] = _createElementVNode("label", { for: "email" }, [
            _createTextVNode("Adresse Email "),
            _createElementVNode("b", { class: "color-danger" }, "*")
          ], -1))
        ])
      ]),
      (!!errors['email'])
        ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(errors['email']), 1))
        : _createCommentVNode("", true),
      (!__props.hideSubmitButton)
        ? (_openBlock(), _createElementBlock("button", {
            key: 4,
            type: "button",
            id: "btn_create_account",
            class: "btn flex-center mt-8 mb-7",
            onClick: _cache[12] || (_cache[12] = ($event: any) => (onSubmit()))
          }, [...(_cache[33] || (_cache[33] = [
            _createElementVNode("img", {
              src: "/icons/icon-valider.svg",
              class: "btn-icon",
              alt: ""
            }, null, -1),
            _createElementVNode("span", null, "Créer le compte", -1)
          ]))]))
        : _createCommentVNode("", true)
    ], 2)
  ], 2))
}
}

})